import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quejas_denuncias',
  templateUrl: './quejas_denuncias.component.html',
  styleUrls: ['./quejas_denuncias.component.css']
})
export class Quejas_denunciasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
